export default __webpack_public_path__ + "static/media/tarang1.fd57b585.jpg";